import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const VfText = {
  light: {
    fontFamily: Fonts.type.VodafoneLt,
  },
  regular: {
    fontFamily: Fonts.type.VFFont,
  },
  bold: {
    ...Fonts.type.bold,
  },
  h1: {
    mobile: {
      fontSize: 32,
      lineHeight: 40,
    },
    tablet: {
      fontSize: 56,
      lineHeight: 62,
    },
    desktop: {
      fontSize: 64,
      lineHeight: 72,
    },
  },
  h2: {
    mobile: {
      fontSize: 28,
      lineHeight: 36,
    },
    tablet: {
      fontSize: 40,
      lineHeight: 48,
    },
    desktop: {
      fontSize: 56,
      lineHeight: 62,
    },
  },
  h3: {
    mobile: {
      fontSize: 24,
      lineHeight: 30,
    },
    tablet: {
      fontSize: 34,
      lineHeight: 40,
    },
    desktop: {
      fontSize: 40,
      lineHeight: 48,
    },
  },
  h4: {
    mobile: {
      fontSize: 20,
      lineHeight: 28,
    },
    tablet: {
      fontSize: 24,
      lineHeight: 30,
    },
    desktop: {
      fontSize: 28,
      lineHeight: 34,
    },
  },
  h5: {
    mobile: {
      fontSize: 18,
      lineHeight: 24,
    },
    tablet: {
      fontSize: 20,
      lineHeight: 28,
    },
    desktop: {
      fontSize: 20,
      lineHeight: 28,
    },
  },
  body: {
    mobile: {
      fontSize: 16,
      lineHeight: 22,
    },
    tablet: {
      fontSize: 18,
      lineHeight: 24,
    },
    desktop: {
      fontSize: 18,
      lineHeight: 24,
    },
  },
  footnote: {
    mobile: {
      fontSize: 14,
      lineHeight: 18,
    },
    tablet: {
      fontSize: 14,
      lineHeight: 18,
    },
    desktop: {
      fontSize: 14,
      lineHeight: 18,
    },
  },
  loader: {
    alignItems: 'center',
  },
}

export default VfText
